import { useNavigationAlertStore } from "@voix/store/navigationAlertStore";
import { usePageStore } from "@voix/store/pageStore";
import { abortNavigation, defineNuxtRouteMiddleware } from "#imports";
export default defineNuxtRouteMiddleware((to, from) => {
  const pageStore = usePageStore();
  const navigationAlertStore = useNavigationAlertStore();
  if (from.name === "voix-studio-en" && to.name !== "voix-studio-en") {
    if (pageStore.currentPage?.current_release?.status === "draft") {
      if (navigationAlertStore.currentAlert !== "unsaved-draft") {
        navigationAlertStore.setAlert("unsaved-draft", to, from);
        return abortNavigation();
      }
    }
  }
});
